export default __webpack_public_path__ + "static/media/usdc.a46968c4.svg";